
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpsertBudgetEntryItemDtoFormGroup() {
return new FormGroup({
    budgetAccountId: new FormControl<number | undefined>(undefined, [Validators.required]),
    businessdivisionId: new FormControl<number | undefined>(undefined, [Validators.required]),
    businessunitId: new FormControl<number | undefined>(undefined),
    year: new FormControl<number | undefined>(undefined, [Validators.required]),
    month: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1), Validators.max(12)]),
    sollValue: new FormControl<number | undefined>(undefined),
    istValue: new FormControl<number | undefined>(undefined),
})
;
}
      